<template>
  <!-- 红包管理-继承红包管理 -->
  <div class="inherit_redenvelope-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input
            v-model.trim="query.id"
            placeholder="请输入用户ID"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryUser">查询添加</el-button>
        </el-form-item>
      </el-form>

      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="最低">
          <el-input
            v-model.trim="formInline.low_amount"
            placeholder="请输入最低值"
          ></el-input>
        </el-form-item>
        <el-form-item label="最高">
          <el-input
            v-model.trim="formInline.high_amount"
            placeholder="请输入最高值"
          ></el-input>
        </el-form-item>
        <el-form-item label="充值限制">
          <el-input
            v-model.trim="formInline.recharge_amount"
            placeholder="请输入充值限制"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addRedEnvelope"
            :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="logVisible = true"
            >记录日志</el-button
          >
        </el-form-item>
      </el-form>
    </header>

    <!-- body内容主体 -->
    <div class="body-box">
      <p class="countNum">共 {{ userList.length }} 个用户</p>
      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="userList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="用户ID" width="120" align="center">
        </el-table-column>
        <el-table-column label="用户名称" width="120" align="center">
          <template slot-scope="scope">
            <el-image
              style="
                width: 30px;
                height: 30px;
                border-radius: 50%;
                vertical-align: middle;
                margin-right: 5px;
              "
              :src="scope.row.avatar || default_avatar"
              fit="cover"
            ></el-image>
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="phone" label="电话号码" align="center">
        </el-table-column>
        <el-table-column prop="type" label="用户类型" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="parseInt(row.type) === 1" type="info"
              >普通用户</el-tag
            >
            <el-tag v-if="parseInt(row.type) === 2" type="success">主播</el-tag>
            <el-tag v-if="parseInt(row.type) === 7" type="success">主播（新）</el-tag>
            <el-tag v-if="parseInt(row.type) === 3" type="primary"
              >测试账号</el-tag
            >
            <el-tag v-if="parseInt(row.type) === 4" type="warning">代理</el-tag>
            <el-tag v-if="parseInt(row.type) === 5" type="warning"
              >代&nbsp;理</el-tag
            >
            <el-tag v-if="parseInt(row.type) === 6" type="warning"
              >试用期代理</el-tag
            >
            <el-tag v-if="parseInt(row.type) === 9" type="warning"
              >代&nbsp;&nbsp;理</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="status" label="账户状态" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="parseInt(row.status) === 1" type>正常</el-tag>
            <el-tag v-if="parseInt(row.status) === 2" type="info">冻结</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="user_tag" label="用户标签" align="center">
        </el-table-column>
        <el-table-column prop="account_balance" label="钻石余额" align="center">
        </el-table-column>
        <el-table-column prop="shop_balance" label="金币余额" align="center">
        </el-table-column>
        <el-table-column prop="recharge_amount" label="总充值额" align="center">
        </el-table-column>
        <el-table-column
          prop="total_take_back_amount"
          label="总取回额"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="backpack_amount" label="背包金额" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="加入时间" align="center">
        </el-table-column>
        <el-table-column prop="ip" label="登录ip"> </el-table-column>
      </el-table>
    </div>

    <InheritLogDialog
      :visible="logVisible"
      @close="logVisible = false"
    ></InheritLogDialog>
  </div>
</template>
<script>
import { delData, getData, patchData, postData } from '../../http'
import InheritLogDialog from '../../components/redpacket/InheritLogDialog'

export default {
  name: 'inherit_redenvelope',
  components: {
    InheritLogDialog
  },
  data() {
    return {
      logVisible: false,//记录显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮动画
      multipleSelection: [],//被选中的数据数组
      addLock: false,//赠送是点击确认的锁
      default_avatar: require('../../assets/user/default-avatar.png'),//默认用户头像
      query: {//查询信息
        id: undefined
      },
      formInline: {
        user_id: '',
        low_amount: undefined,
        high_amount: undefined,
        recharge_amount: '0'
      },
      userList: []
    }
  },
  created() {
  },
  methods: {
    queryUser() {
      //查询用户
      if (this.userList.length > 0) {
        for (let i = 0; i < this.userList.length; i++) {
          if (this.userList[i].id == this.query.id) {
            this.$message.error('用户已在队列中')
            return
          }
        }
      }

      if (!this.query.id) {
        this.$message.error('用户ID不能为空')
        return
      } else {
        this.loading = true;
        let params = this.query
        getData('users', params).then((res) => {
          if (res.data && res.data.length != 0) {
            // this.userList.push(res.data[0]);
            this.userList = res.data;
            setTimeout(() => {
              //延迟一下，不然复选框无法变为选中状态
              this.$refs.multipleTable.toggleRowSelection(res.data[0], true);
            }, 0)
          } else {
            this.$message.error('找不到此用户')
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleSelectionChange(val) {
      //点击勾选
      this.multipleSelection = val;
    },
    addRedEnvelope() {
      //确认提交
      if (this.multipleSelection.length <= 0) {
        this.$message.error('请选择用户')
        return
      } else if (!this.formInline.low_amount || !this.formInline.high_amount) {
        this.$message.error('最低和最高必填')
        return
      } else {
        this.buttonLoading=true
        if (this.addLock) {
          this.$message.error('正在请求，请勿重复点击')
          return
        }
        this.addLock = true//加锁
        this.formInline.user_id = this.multipleSelection[0].id
        postData('sendRedInherits', this.formInline).then(res => {
          if (res) {
            this.$message.success('添加成功！')
          }
        }).finally(() => {
          this.addLock = false//解锁
          this.buttonLoading=false
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.inherit_redenvelope-box {
  header {
    margin-bottom: 10px;
  }

  .body-box {
    //设置标题与表格的复选框对齐
    & /deep/.el-table th > .cell {
      padding-left: 14px;
      padding-right: 14px;
    }

    .countNum {
      margin-bottom: 5px;
    }
  }
}
</style>